import { Injectable } from '@angular/core';
import { ResourceName } from '../../../../../backend/src/core/resource-name';

@Injectable({
  providedIn: 'root',
})
export class InitDataService {
  readonly resourceName = ResourceName.initData;

  constructor() {}
}
